import { createSelector } from 'reselect';
import { isInArray } from '../../../core/util/is-in-array';
import { File } from '../../../vas/business-objects/file/file.model';
import { Report } from '../../../vas/business-objects/report/report.model';
import {
    EmailAttachmentPickerValue,
    EmailAttachmentPickerValueItemTypeEnum
} from '../../atoms/email-attachment-picker/email-attachment-picker-value';
import { AttachmentOption } from './email-attachment-picker-modal';
import * as actions from './email-attachment-picker-modal.actions';

export interface State {
    attachments: EmailAttachmentPickerValue;
    files: Array<File>;
    reports: Array<Report>;
    selectedFiles: Array<string>;
    selectedReports: Array<string>;
}

export const initialState: State = {
    attachments: [],
    files: [],
    reports: [],
    selectedFiles: [],
    selectedReports: []
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {

    switch (action.type) {
        case actions.LOAD: {
            return {
                ...initialState
            };
        }
        case actions.LOAD_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                selectedFiles: [],
                selectedReports: []
            };
        }
        case actions.SET_SELECTED_FILES: {
            return {
                ...state,
                selectedFiles: action.payload
            };
        }
        case actions.SET_SELECTED_REPORTS: {
            return {
                ...state,
                selectedReports: action.payload
            };
        }
        case actions.TOGGLE_ALL_FILES: {
            return {
                ...state,
                selectedFiles: action.payload ? state.files.map(file => file.id) : []
            };
        }
        case actions.TOGGLE_ALL_REPORTS: {
            return {
                ...state,
                selectedReports: action.payload ? state.reports.map(report => report.id) : []
            };
        }
        case actions.TOGGLE_FILE: {
            return {
                ...state,
                selectedFiles: action.payload.selected ?
                    state.selectedFiles.filter(id => id !== action.payload.file.id) :
                    Array.from(new Set([...state.selectedFiles, action.payload.file.id]))

            };
        }
        case actions.TOGGLE_REPORT: {
            return {
                ...state,
                selectedReports: action.payload.selected ?
                    state.selectedFiles.filter(id => id !== action.payload.report.id) :
                    Array.from(new Set([...state.selectedReports, action.payload.report.id]))
            };
        }
        default: {
            return state;
        }
    }
}

export const getState = (state: any): State => state.emailAttachmentPickerModal;

export const getFiles = createSelector(getState, state => state.files);

export const getReports = createSelector(getState, state => state.reports);

export const getSelectedFiles = createSelector(getState, state => state.selectedFiles);

export const getSelectedReports = createSelector(getState, state => state.selectedReports);

export const getFileOptions = createSelector(getFiles, getSelectedFiles, (files, ids): Array<AttachmentOption> => {
    return [...files]
        .sort((a, b) => a.sequence - b.sequence)
        .map(file => ({
            id: file.id,
            text: file.name,
            type: EmailAttachmentPickerValueItemTypeEnum.FILE,
            selected: isInArray(file.id, ids),
            file,
            report: undefined,
            created: file.serverCreated
        }));
});

export const getReportOptions = createSelector(getReports, getSelectedReports, (reports, ids): Array<AttachmentOption> => {
    return [...reports]
        .map(report => ({
            id: report.id,
            text: report.title,
            type: EmailAttachmentPickerValueItemTypeEnum.REPORT,
            selected: isInArray(report.id, ids),
            file: undefined,
            report,
            created: report.serverCreated
        }))
        .sort((a, b) => b.created.localeCompare(a.created));
});

export const getSelectedOptions = createSelector(getReportOptions, getFileOptions, (reportOptions, fileOptions): EmailAttachmentPickerValue => {
    return [
        ...reportOptions
            .filter(option => option.selected)
            .map(option => ({
                id: option.id,
                text: option.text,
                value: option.id,
                type: EmailAttachmentPickerValueItemTypeEnum.REPORT
            })),
        ...fileOptions
            .filter(option => option.selected)
            .map(option => ({
                id: option.id,
                text: option.text,
                value: option.id,
                type: EmailAttachmentPickerValueItemTypeEnum.FILE
            }))
    ];
});



// WEBPACK FOOTER //
// ./src/app/modals-popovers/email-attachment-picker-modal/email-attachment-picker-modal.reducer.ts